/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * agora/v1/user.proto
 * OpenAPI spec version: version not set
 */

/**
 * Represents the onboarding state of a user.

 - ONBOARDING_STATE_UNSPECIFIED: Unspecified onboarding state.
 - WORKSPACE_CREATION_PENDING: User needs to create a workspace.
 - COMPLETED: User has completed onboarding.
 */
export type V1OnboardingState =
  (typeof V1OnboardingState)[keyof typeof V1OnboardingState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1OnboardingState = {
  ONBOARDING_STATE_UNSPECIFIED: 'ONBOARDING_STATE_UNSPECIFIED',
  WORKSPACE_CREATION_PENDING: 'WORKSPACE_CREATION_PENDING',
  COMPLETED: 'COMPLETED',
} as const;
